<template>
  <div class="quote">
    <form
      class="login"
      @submit.prevent="request"
    >
      <div v-html="$error.handle(error)" />
      <template v-if="step == 1">
        <div class="form-group">
          <label>Procuring Entity</label>
          <select
            v-model="quote.counterparty"
            class="form-control"
            required=""
          >
            <option
              v-for="(party,i) in counter_parties"
              :key="i"
              :value="party.secret"
            >
              {{ party.name }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label for="amount">Bid Amount</label>
          <vue-numeric
            v-model="quote.amount"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label for="period">Tenure Period (days)</label>
          <vue-numeric
            v-model="quote.tenure"
            class="form-control"
            name="tenure_duration"
          />
        </div>
        <div
          class="form-group"
          style="text-align: right;"
        >
          <a
            href="#"
            class="btn btn-primary"
            @click.prevent="step = 2"
          >Next</a>
        </div>
      </template>
      <template v-if="step == 2">
        <div class="form-group">
          <label for="email">Your Email</label>
          <input
            id="email"
            v-model="quote.email"
            type="email"
            class="form-control"
            required=""
          >
        </div>
        <div class="form-group">
          <label for="phone_number">Your Phone Number</label>
          <phone-number v-model="quote.phone" />
        </div>
        <div class="form-group">
          <input
            id="terms"
            v-model="terms"
            type="checkbox"
            value="1"
            required=""
          >
          <label
            for="terms"
            style="margin-left: 10px;"
          >I have read the <a
            href="#"
            @click.prevent="show_terms=true"
          >terms and conditions.</a></label>
        </div>
        <div
          class="form-group"
          style="text-align: right;"
        >
          <a
            class="btn btn-info pull-left"
            href="#"
            @click.prevent="step=1"
          >Back</a>
          <button class="btn btn-primary">
            Request Quote
          </button>
        </div>
      </template>
      <template v-if="step == 3">
        <div class="sent">
          <h4>Success!</h4>
          <p>The quotation of KES {{ $number.format(quote.amount) }} is:</p>
          <table class="table">
            <tbody>
              <tr>
                <td>Bidbond charge</td>
                <td>{{ $number.format(price.bid_bond_charge) }}</td>
              </tr>
              <tr>
                <td>Excise duty</td>
                <td>{{ $number.format(price.excise_duty) }}</td>
              </tr>
              <tr>
                <td>Indemnity charge</td>
                <td>{{ $number.format(price.indemnity_cost) }}</td>
              </tr>
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>KES {{ $number.format(price.total) }}</strong></td>
              </tr>
            </tbody>
          </table>
          <div style="text-align: center;">
            <a
              href="#"
              class="btn btn-primary"
              @click.prevent="sendMail"
            ><i class="fa fa-envelope" /> SEND QUOTE TO MAIL</a>
            <br>
            <p>OR</p>
            <router-link
              :to="{ name: 'login' }"
              class="btn btn-primary"
            >
              GENERATE BIDBOND
            </router-link>
          </div>
        </div>
      </template>
      <template v-if="step == 4">
        <div class="sent">
          <h4>Success!</h4>
          <p>Your quote has been generated and sent to {{ quote.email }}</p>
          <router-link
            :to="{ name: 'login' }"
            class="btn btn-primary"
          >
            GENERATE BIDBOND
          </router-link>
        </div>
      </template>
    </form>
    <modal
      :show-modal="show_terms"
      @close="show_terms=false"
    >
      <template v-slot:header>
        <h5>Terms and Conditions</h5>
      </template>
      <div>
        <terms-and-conditions />
      </div>
      <hr>
      <div class="form-group">
        <a
          href="#"
          class="btn btn-primary"
          @click.prevent="show_terms = false; terms=1"
        >Accept Terms and Conditions</a>
        <a
          href="#"
          class="btn btn-danger pull-right"
          @click.prevent="show_terms = false"
        >Cancel</a>
      </div>
    </modal>
  </div>
</template>

<script>
import TermsAndConditions from "@/components/Guest/Terms.vue";

export default {
  components: {
    TermsAndConditions
  },

  data() {
    return {
      quote: {
        tenure: '',
        amount: '',
        counterparty: '',
        email: '',
        phone: '',
        country: 'kenya'
      },
      terms: '',
      counter_parties: [],
      step: 1,
      price: {},
      show_terms: false,
      error: ''
    }
  },

  mounted() {
    this.fetch();
  },

  methods: {
    fetch() {
      this.$axios.get('/api/v1/guest-counterparties').then(response => {
        this.counter_parties = response.data.data;
      });
    },

    request() {
      this.$axios.post('/api/v1/quote', this.quote).then(response => {
        this.price = response.data;
        this.step = 3;
        this.error = '';
      }).catch(error => {
        this.error = error.response;
      });
    },

    sendMail() {
      this.$axios.post('/api/v1/send-quote', this.quote).then(response => {
        this.price = response.data;
        this.step = 4;
      }).catch(error => {
        this.error = error.response;
      });
    }
  }
}
</script>
